module.exports = __webpack_public_path__ + "assets/suanpan.99bad6dc.svg";